type ILanguage = {
    id:
        | "en"
        | "cs"
        | "sk"
        | "pl"
        | "de"
        | "pt"
        | "es"
        | "ja"
        | "zh"
        | "tr"
        | "sv"
        | "nl"
        | "it"
        | "fi"
        | "ro"
        | "ko"
        | "vi";

    name: string;
};

export const languages: ILanguage[] = [
    {
        id: "en",
        name: "English",
    },
    {
        id: "cs",
        name: "Čeština",
    },
    {
        id: "sk",
        name: "Slovak",
    },
    {
        id: "pl",
        name: "Polish",
    },
    {
        id: "de",
        name: "German",
    },
    {
        id: "pt",
        name: "Portuguese",
    },
    {
        id: "es",
        name: "Spanish",
    },
    {
        id: "ja",
        name: "Japanese",
    },
    {
        id: "zh",
        name: "Chinese",
    },
    {
        id: "tr",
        name: "Turkish",
    },
    {
        id: "sv",
        name: "Swedish",
    },
    {
        id: "nl",
        name: "Dutch",
    },
    {
        id: "it",
        name: "Italian",
    },
    {
        id: "fi",
        name: "Finnish",
    },
    {
        id: "ro",
        name: "Romanian",
    },
    {
        id: "ko",
        name: "Korean",
    },
    {
        id: "vi",
        name: "Vietnamese",
    },
];
